/** Utilidades mínimas para validar vigencia del JWT en cliente (sin verificar firma). */

const MARGEN_VIGENCIA_MS = 30_000;

function decodeJwtPayload(token: string): Record<string, unknown> | null {
  const d1 = token.indexOf('.');
  if (d1 < 0) return null;
  const d2 = token.indexOf('.', d1 + 1);
  if (d2 <= d1 + 1) return null;
  let b64 = token.slice(d1 + 1, d2).replace(/-/g, '+').replace(/_/g, '/');
  const pad = b64.length % 4;
  if (pad) b64 += '='.repeat(4 - pad);
  try {
    const json = atob(b64);
    const parsed = JSON.parse(json);
    return parsed && typeof parsed === 'object' ? (parsed as Record<string, unknown>) : null;
  } catch {
    return null;
  }
}

function jwtExpMs(token: string): number | null {
  const payload = decodeJwtPayload(token);
  if (!payload) return null;
  const exp = payload['exp'];
  if (typeof exp === 'number' && Number.isFinite(exp)) return Math.trunc(exp) * 1000;
  if (typeof exp === 'string' && /^\d+$/.test(exp.trim())) {
    return Number.parseInt(exp.trim(), 10) * 1000;
  }
  return null;
}

function jwtIatMs(token: string): number | null {
  const payload = decodeJwtPayload(token);
  if (!payload) return null;
  const iat = payload['iat'];
  if (typeof iat === 'number' && Number.isFinite(iat)) return Math.trunc(iat) * 1000;
  if (typeof iat === 'string' && /^\d+$/.test(iat.trim())) {
    return Number.parseInt(iat.trim(), 10) * 1000;
  }
  return null;
}

/** Token usable: sin `exp` se asume válido hasta que el API responda 401. */
export function jwtEstaVigente(token: string | null | undefined, margenMs = MARGEN_VIGENCIA_MS): boolean {
  if (!token?.trim()) return false;
  const exp = jwtExpMs(token.trim());
  if (exp == null) return true;
  return Date.now() + margenMs < exp;
}

/** Mayor `iat` = sesión emitida más recientemente. */
export function jwtEmitidoEnMs(token: string): number {
  return jwtIatMs(token) ?? 0;
}
